import React, { useState, useEffect} from "react";
import {
    Box,
    Text,
    Button,
    Spinner
} from "@chakra-ui/react";
import { getCachedConfig } from '../utils/configManager';


interface AppointmentCardProps {
    date: string;
    day: string;
    month: string;
    time: string;
    doctorName: string;
    clinicName: string;
    appointmentType: string;
    patientName: string;
    appointmentId: string;
    onCancel: () => void;
}

const AppointmentCard: React.FC<AppointmentCardProps> = ({
    date,
    day,
    month,
    time,
    doctorName,
    clinicName,
    appointmentType,
    patientName,
    appointmentId,
    onCancel,
}) => {
    const [isLoading, setIsLoading] = useState(false);

     // eslint-disable-next-line
  const [config, setConfig] = useState<any>(null);
  const colors = config?.colorScheme || {};

  useEffect(() => {
    const config = getCachedConfig();
    if (config) {
      setConfig(config);
    }
  }, []);

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            bg="#FFFFFF"
            border="1px solid"
            borderColor={colors.buttonBg || "#B92F2F"}
            borderRadius="xl"
            boxShadow="md"
            width={"100%"}
            overflow="hidden"
            gap={2}
        >
            {/* Date Section */}
            <Box
                bg={colors.buttonBg || "#B92F2F"}
                color="white"
                display="flex" flexDirection="column"
                textAlign="center"
                alignItems="center"
                justifyContent="center"

                height={'100%'}
                minW="100px"
            >
                <Text fontSize="30px" fontWeight="bold" mt={-2}>
                    {date}
                </Text>
                <Text fontWeight="bold" fontSize="xs" mt={-2}>{day}</Text>
                <Text fontWeight="bold" mt={-2} fontSize="sm">{month}</Text>
                <Text fontWeight="bold" mt={-1} fontSize="sm">{time}</Text>
            </Box>

            <Box display="flex"
                flexDirection={["column", "column", "row"]}
                justifyContent={"space-between"}
                width={"100%"}
                p={5}>
                <Box >
                <Text fontWeight={'bold'}>
                        {doctorName}
                        </Text>
                    <Text fontSize="sm">{clinicName}</Text>
                    <Text fontSize="sm">
                        {appointmentType}
                    </Text>
                </Box>

                <Box display="flex" gap={2} alignItems="center" flexDirection={["column", "column"]} >
                    <Box width={'100%'}>
                        <Text fontWeight="bold">Patient: {patientName}</Text>
                        <Text fontSize="xs" >
                            AID: {appointmentId}
                        </Text>
                        <Button
                        bg={colors.buttonBg || "#B92F2F"}
                        color="white"
                        fontWeight="bold"
                        borderRadius="30"
                        fontSize={"xs"}
                        size={"xs"}
                        width={'220px'}
                        onClick={() => {
                            setIsLoading(true); 
                            onCancel(); 
                        }}
                        
                    >
                        {isLoading ? <Spinner size="xs" color="white" /> : "Cancel Appointment"}
                    </Button>
                    </Box>

                    
                </Box>
            </Box>

            <Box
                display={["none", "none", "block"]}
                bg={colors.buttonBg || "#B92F2F"}
                width="25px"
                fontSize="25px"
                height={"100%"}
                p={3}
                pt={14}
            >
                {" "}
            </Box>
        </Box>
    );
};

export default AppointmentCard;
